import { useQuery } from "@tanstack/vue-query";
import { readonly } from "vue";
import { queries } from "./queries";

export function useAxureCloudConfig() {
  const { data: config } = useQuery(queries.config());

  return readonly(config);
}
